import './base';
import {
  Category
} from './src/category';
import {
  initSlider
} from './src/photo-slider';
import {
  initSubcategorySlider
} from './src/popular-subcategory';
import {
  initLinkSlider
} from './src/popular-link';

new Category();
initSlider();
initSubcategorySlider();
initLinkSlider();
